const mobileMenuButton = document.getElementById('mobile-menu-button');
const mobileMenuNav = document.getElementById('mobile-menu-nav');

if (mobileMenuButton && mobileMenuNav) {
    mobileMenuButton.addEventListener('click', () => {
        mobileMenuNav.classList.toggle('d-none');
    });
}
